export default __webpack_public_path__ + "static/HL7-d71dfbf9c92e6e013581676eef141543.png";